import {
  AlignItems,
  Box,
  ColorPreset,
  H3,
  JustifyContent,
  P,
  Text,
  TextAlign,
  TypePreset,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";
import Image from "next/image";

import MarketingImage from "src/assets/png/optimised-signup.png";

export const SignupMarketing = () => (
  <Box
    layout="flex"
    flexDirection="column"
    justifyContent={JustifyContent.Center}
    minHeight="100dvh"
    gutterV={6}
    gutterH={3}
  >
    <Box layout="flex" flexDirection="column" alignItems={AlignItems.Center}>
      <Box maxWidth="380px">
        <Image
          src={MarketingImage}
          alt="The easy way to collect payments"
          width={630}
          height={581}
          style={{
            maxWidth: "100%",
            height: "auto",
            position: "relative",
          }}
          priority={false}
        />
      </Box>
      <Box css={{ textWrap: "balance" }}>
        <H3
          color={ColorPreset.TextOnLight_01}
          spaceBelow={1}
          size={9}
          textAlign={TextAlign.Center}
        >
          <Trans id="optimised-sign-up.form.left-column.the-easy-way-to">
            The easy way to
          </Trans>
          <Text layout="block">
            <Trans id="optimised-sign-up.form.left-column-heading.collect-payments">
              collect payments
            </Trans>
          </Text>
        </H3>
        <P
          color={ColorPreset.TextOnLight_01}
          preset={TypePreset.Body_03}
          textAlign={TextAlign.Center}
          css={{
            maxWidth: "500px",
          }}
        >
          <Trans id="optimised-sign-up.form.left-column.text">
            GoCardless helps you collect payments from your customers easily and
            without expensive fees.
          </Trans>
        </P>
      </Box>
    </Box>
  </Box>
);
